import { BaseModel } from "@blue-chip/core";
import Funding from "./Funding";

export default class FundingPayment extends BaseModel {
  static get belongsTo() {
    return [Funding];
  }
}
